import React from "react";
import { CtaButton } from "@/components/CtaButton";
import { SITE } from "@/constants/testIds";

export const HomeShopTeaserSection = ({ shopUrl }) => (
    <section data-testid={SITE.homeShopTeaser} className="py-12">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <div
                data-testid={SITE.shopTeaserBanner}
                className="rounded-3xl bg-moss text-cream p-8 sm:p-12 relative overflow-hidden"
            >
                <div className="absolute inset-0 opacity-10 pointer-events-none">
                    <img
                        src="https://images.unsplash.com/photo-1517673400267-0251440c45dc?w=1600&auto=format&fit=crop"
                        alt="botanicals"
                        className="h-full w-full object-cover"
                    />
                </div>
                <div className="relative grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
                    <div>
                        <p className="font-accent text-xs text-terracotta/90">ONLINE SHOP</p>
                        <h3 className="mt-2 font-display text-3xl sm:text-4xl leading-tight">
                            Carefully curated Ayurvedic herbs, oils &amp; teas
                        </h3>
                        <p className="mt-3 max-w-prose text-cream/85">
                            Continue your practice at home with the same products Riley uses in clinic.
                        </p>
                    </div>
                    <div className="md:justify-self-end">
                        <CtaButton
                            href={shopUrl || "https://choiceayurveda.com/onlineshop"}
                            variant="accent"
                            testid={SITE.shopTeaserCta}
                        >
                            Visit the shop
                        </CtaButton>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default HomeShopTeaserSection;
